const sameMachine = (entry, target) =>
  entry.length === target.length && entry.every((el, i) => el === target[i]);

const getDevices = (location) => location?.devices || location || {};

export const selectSettingsMachineHandler = (
  option,
  machine,
  extraOption,
  data,
  selectedMachines,
  isMachineSelected
) => {
  const locationIdx = Object.keys(data || {}).indexOf(option);
  let newSelectedMachine;
  let specLocationIdx;
  let machineIdx;
  let select;

  if (extraOption) {
    specLocationIdx = Object.keys(data[option].subLocations || {}).indexOf(
      extraOption
    );
    machineIdx = Object.keys(
      getDevices(data[option].subLocations?.[extraOption])
    ).indexOf(machine);
    select = !isMachineSelected?.[locationIdx]?.[specLocationIdx]?.[machineIdx];

    newSelectedMachine = select
      ? [...selectedMachines, [option, extraOption, machine]]
      : selectedMachines.filter(
          (el) => !sameMachine(el, [option, extraOption, machine])
        );
  } else {
    machineIdx = Object.keys(getDevices(data[option])).indexOf(machine);
    select = !isMachineSelected?.[locationIdx]?.[machineIdx];

    newSelectedMachine = select
      ? [...selectedMachines, [option, machine]]
      : selectedMachines.filter((el) => !sameMachine(el, [option, machine]));
  }

  return {
    locationIdx,
    specLocationIdx,
    machineIdx,
    newSelectedMachine,
    select,
  };
};
